<p-messages severity="error"  >
    <ng-template pTemplate >
        <span class="static-content-message" [innerHTML] = "message"></span>
    </ng-template>
</p-messages>
